<script setup>
import { computed } from 'vue'

const PROD_APP_HOSTNAMES = ['app.dss360.app', 'appdss360.consultdss.cn', 'dss360.consultdss.com']

const label = computed(() => {
  const appHostname = window.location.hostname
  const apiUrl = import.meta.env.VITE_API_URL

  try {
    const apiHostname = new URL(apiUrl ?? '').hostname
    const isProduction = PROD_APP_HOSTNAMES.includes(appHostname)
    if (isProduction)
      return null

    if (appHostname === 'localhost') {
      return apiHostname.replace(/\.dss360\.app$/, '') || apiHostname || 'local'
    }

    return appHostname.replace(/\.dss360\.app$/, '') || apiHostname.replace(/\.dss360\.app$/, '') || 'local'
  }
  catch {
    return null
  }
})
</script>

<template>
  <div
    v-if="label"
    class="fixed -top-0.5 left-0 rounded-br-lg z-9999 bg-dss-primary-500 text-white text-xs font-semibold px-2 py-1 select-none pointer-events-none"
  >
    {{ label }}
  </div>
</template>
